import { TierIIReportEncampStatus, TierIIReportKind } from "encamp-prisma/generated/browser";

/**
 * A facility-year counts as filed when an ANNUAL Tier II report reached
 * FILING_COMPLETE. Both the merge's filed-year acknowledgement (server) and
 * the wizard's filed classification (client) apply this one rule. Other
 * report kinds (INITIAL, REVISION, UPDATE, NEWLY_NOT_REPORTING) can also
 * reach FILING_COMPLETE for the same facility-year without representing the
 * annual filing this rule cares about.
 */
export function isFiledAnnualTierIIReport(report: {
  encampStatus: string;
  reportKind: string;
}): boolean {
  return (
    report.encampStatus === TierIIReportEncampStatus.FILING_COMPLETE &&
    report.reportKind === TierIIReportKind.ANNUAL
  );
}
